// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__QbqkP","imageIcon":"Icon_imageIcon__fdO+k"};